export default __webpack_public_path__ + "static/media/microsoft-1.262c73c9.svg";